import React, { Component } from "react";
import { loginPassword } from "../../services/rest";
import LoginDetails from "./LoginDetails";
import Validator from "../../utils/Validator";
import VodCookieGenerator from "../../utils/vod-cookie-generator";
import ErrorHandler from "../../utils/error-handler";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TaggingHelper from "../../tagging/tagging-helper";
import { REDIRECT_TO_PASSWORD_RESET } from "../../utils/constants";

toast.configure();

class LoginForm extends Component {
  defaultState = {
    hidden: true,
    username: "",
    password: "",
    isUsernameValid: false,
    isPasswordValid: false
  };

  constructor(props) {
    super(props);
    if (props.data && props.data.previousState) {
      this.state = {
        ...props.data.previousState
      };
    } else {
      this.state = this.defaultState;
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.props.data && this.props.data.toastMessage) {
      toast.success(this.props.data.toastMessage, {
        position: toast.POSITION.BOTTOM_LEFT
      });
    }
    TaggingHelper.loginPasswordLandingEvent();
  }

  _onPasswordLogin = (e) => {
    const { goto } = this.props;
    e.preventDefault();
    this.props.showUILoader(true);
    loginPassword(
      this.state.username,
      this.state.password,
      this.props.redirectUrl
    )
      .then((response) => {
        if (response.data && response.data.result) {
          TaggingHelper.loginPasswordSuccessEvent();

          if (!response.data.result.result && response.data.result.redirect === REDIRECT_TO_PASSWORD_RESET) {

            ErrorHandler.handleTemporaryPassword(
              { username: this.state.username },
              goto
            );

            return;
          }

          const targetUrl =
            process.env.REACT_APP_BASE_URL + response.data.result.redirect;
          if (this.props.redirectUrl) {
            VodCookieGenerator.setVodaCookie("login-ui-redirection", targetUrl);
          }
          window.location.href = targetUrl;
        } else {
          throw new Error("UNEXPECTED_ERROR");
        }
      })
      .catch((error) => {
        ErrorHandler.handleApiError(
          error,
          this.props.goto,
          this.state,
          "LOGIN"
        );
        const errorMessage = ErrorHandler.getErrorMessage(error).errorMessage;
        TaggingHelper.loginApiErrorEvent(errorMessage);
      })
      .finally(() => {
        this.props.showUILoader(false);
      });
  };

  canBeSubmitted() {
    const { username, password } = this.state;
    return (
      Validator.isValidUsername(username) && Validator.isValidPassword(password)
    );
  }

  handleSubmit = (e) => {
    if (this.canBeSubmitted()) {
      e.preventDefault();
      return;
    }
  };

  handleUsernameChange = (e) => {
    const value = e.target.value;
    this.setState({
      username: value,
      isUsernameValid: Validator.isValidUsername(value)
    });
  };

  handlePasswordChange = (e) => {
    const value = e.target.value;
    this.setState({
      password: e.target.value,
      isPasswordValid: Validator.isValidPassword(value)
    });
  };

  toggleShow = () => {
    this.setState((pstate) => ({
      hidden: !pstate.hidden
    }));
  };

  handleScreenChange = (stateUpdates = {}) => {
    this.setState({ ...this.defaultState, ...stateUpdates });
  };

  render() {
    const { goto } = this.props;
    return (
      <div>
        <LoginDetails
          hidden={this.state.hidden}
          password={this.state.password}
          username={this.state.username}
          isPasswordValid={this.state.isPasswordValid}
          handleUsernameChange={this.handleUsernameChange}
          handlePasswordChange={this.handlePasswordChange}
          _onPasswordLogin={this._onPasswordLogin}
          isUsernameValid={this.state.isUsernameValid}
          toggleShow={this.toggleShow}
          goto={goto}
          isOldLogin={this.props.isOldLogin}
          showUILoader={this.props.showUILoader}
        />
      </div>
    );
  }
}

export default LoginForm;
